import React from 'react'
import { UiCol, UiRowContainer, UiSingleRow } from "../../components/grid-container/GridContainer"
import {
    UiContentWr,
    UiContentCol

} from "../../components/common/UiPageElements";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import Footer from "../../components/footer/Footer";
import IncentiveBanner from './views/IncentiveBanner';
import nyImage from "../../../../styles/img/spin-win-1.jpg";
import nyImage2 from "../../../../styles/img/spin-win-3.jpg";
import nyImage3 from "../../../../styles/img/featured-image.png";
import { Button } from "react-bootstrap";
import { UiCardTitle } from '../../components/common/UiCardTitle';
import { UiBannerBottomBar } from '../../components/common/UiBannerBottomBar';
import { TermsConditions } from './views/TermsConditions';
import { Faq } from './views/Faq';
import bandedBanner from "../../../../styles/img/banded-banner.jpg";
import { TickIcon } from '../../../../styles/img/svg/TickIcon';
import { SuccessInfo } from './views/SuccessInfo';
import { UiTable } from '../../components/common/UiTable';
import Avatar from '../../../../styles/img/Avatar.png';
import UiIncentiveHistoryCard from '../../components/common/UiIncentiveHistoryCard';
import { UiStepsWizard } from '../../components/common/UiStepsWizard';
import { UiSalesChainElement, UiSalesChainElementNoBgWr } from '../../components/common/UiSalesChainElements';
import { UiLeftContentRightThreeImageBlock } from '../../components/common/UiImageBlock';
import { RoadToRewards } from './views/RoadToRewards';
import { OrangeHeartIcon } from '../../../../styles/img/svg/OrangeHeartIcon';
import { UiStatusBottom } from '../../components/common/UiStatusBarBottom';
import RealTimeCodeEntry from "./views/RealTimeCodeEntry"
import TeamMemberTable from './views/TeamMemberTable';



export const IncentivesBanded = (props) => {

    const wizardData = [
        { id: 1, number: "1", title: 'Step 1', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.', status: 'active' },
        { id: 2, number: "2", title: 'Step 2', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.' },
        { id: 3, number: <TickIcon />, title: 'Success', content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nis.', status: "success" },
    ];

    const TableHeaders = [

        { id: 1, th: 'Name' },
        { id: 2, th: 'Sales' },
        { id: 3, th: 'Location' },
        { id: 4, th: 'Department' },
        { id: 5, th: 'Points' },
    ];



    return (
        <>
            <UiMainWrapper>
                <TopHeader />
                <IncentiveBanner
                    topText="Incentive"
                    title="Volvo 
                    Q3 Gold Rush"
                    description="Win up to 20k points per sale
                    lorem epsum text dandom text  Volvo Accessories"
                    sliderCardImage={bandedBanner}
                    content={true}
                    contentTitle="July to September 
                    Retail Incentive"
                    contentTopLeftAlign={true}

                />

                <UiBannerBottomBar
                    prevPage="Campaigns"
                    prevPageLink="/ui"
                    currentPage=" Volvo Q3 Gold Rush"
                    currentPageLink="/ui/incentives-pre-register"
                />

                <RoadToRewards />

                <UiContentWr>
                    <UiRowContainer fluid="fluid">
                        <UiCol lg="8">
                            <UiContentCol>
                                <UiLeftContentRightThreeImageBlock
                                    image1={nyImage}
                                    image2={nyImage2}

                                >
                                    <UiCardTitle title="How fast can you earn?" />
                                    <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>

                                    <hr />

                                    <h3>The clock is ticking</h3>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum tellus elit sed risus. Maecenas eget condimentum velit, sit amet feugiat lectus. Class aptent taciti sociosqu
                                    </p>

                                    <Button to="" className="sb-primary-btn--38" disabled>Join Incentive</Button>
                                </UiLeftContentRightThreeImageBlock>
                            </UiContentCol>
                        </UiCol>
                        <UiCol lg="4">
                            <UiIncentiveHistoryCard
                                heading="My Counting Sales"
                                amount="£443.50"
                                qtyTitle="Latest sales = "
                                rightTitle="Target sales = "
                                rtVal="£25,000"
                            >
                                <UiSalesChainElementNoBgWr>
                                    <UiSalesChainElement salesStatus="Entry confirmed for sale" salesId="NR7107463" date="22 Nov 2022" />
                                    <UiSalesChainElement isActive={true} salesStatus="Entry confirmed for sale" salesId="NR7107463" date="22 Nov 2022" />
                                    <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                    <UiSalesChainElement salesStatus="Verifying Entry for sale" salesId="NR7107463" date="22 Nov 2022" />
                                </UiSalesChainElementNoBgWr>
                            </UiIncentiveHistoryCard>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>


                <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-incentive-process-wrapper">
                        <UiCol lg="8">
                            <UiContentCol>
                                <UiSingleRow className="sb-incentive-process-wrapper__banded">
                                    <UiCol lg="12">
                                        <UiCardTitle title="How this incentive works" />
                                        <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.<br />Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>
                                        <UiStepsWizard
                                            wizardData={wizardData}
                                        />
                                    </UiCol>

                                    {/* <UiCol lg="12">
                                        <UiStatusBottom icon={<OrangeHeartIcon />} >
                                            <p><strong>Lucky Number Prize:</strong>   Weekend break for two</p>

                                            <Button to="" className="sb-primary-btn--38">See your prize</Button>
                                        </UiStatusBottom>
                                    </UiCol> */}
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>

                        <UiCol lg="4" className="sb-real-time-wr">
                            <UiContentCol>
                                <RealTimeCodeEntry />
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>

                <UiContentWr >
                    <UiRowContainer fluid="fluid" className="sb-league-tabl-sec">
                        <UiCol lg="12">
                            <UiContentCol>
                                <UiSingleRow>
                                    <UiCol lg="12" xl="12">
                                        <TeamMemberTable/>
                                    </UiCol>    
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr>


                {/* <UiContentWr>
                    <UiRowContainer fluid="fluid" className="sb-league-tabl-sec">
                        <UiCol lg="12" className="sb-oranged-hover">

                            <UiContentCol>
                                <UiSingleRow className="sb-aligned-center">
                                    <UiCol lg="12">
                                        <div className='sb-league-tabl-sec__header'>
                                            <h2> Manager Dashboard</h2>
                                        </div>
                                    </UiCol>
                                    <UiCol lg="12" xl="8">
                                        <div className='sb-league-tabl-sec__tbl-tp-header'>
                                            <div>
                                                <h4>Your Team (4)</h4>
                                                <p>Your team members</p>
                                            </div>
                                            <Button to="" className="sb-primary-btn--38" disabled>100,250 Points</Button>
                                        </div>
                                        <div className='sb-league-tabl-sec__incentive-joined-sec'>
                                            <UiTable className="sb-white-bg-table sb-manager-tbl" tableHeader={TableHeaders}>
                                                <tr>

                                                    <td>
                                                        <div>
                                                            <img src={Avatar} />
                                                            <span>
                                                                <h4>Brad Simmons</h4>
                                                                <p>Lorem Epsum</p>
                                                            </span>

                                                        </div>
                                                    </td>
                                                    <td >
                                                        <h4>146</h4>
                                                        <p>Confirmed</p>
                                                    </td>
                                                    <td >
                                                        <h4>London</h4>
                                                        <p>UK</p>
                                                    </td>
                                                    <td>
                                                        <h4>Intertico</h4>
                                                        <p>Sales</p>
                                                    </td>
                                                    <td>

                                                        <p>0</p>
                                                    </td>
                                                </tr>

                                                <tr>

                                                    <td>
                                                        <div>
                                                            <img src={Avatar} />
                                                            <span>
                                                                <h4>Brad Simmons</h4>
                                                                <p>Lorem Epsum</p>
                                                            </span>

                                                        </div>
                                                    </td>
                                                    <td >
                                                        <h4>146</h4>
                                                        <p>Confirmed</p>
                                                    </td>
                                                    <td >
                                                        <h4>London</h4>
                                                        <p>UK</p>
                                                    </td>
                                                    <td>
                                                        <h4>Intertico</h4>
                                                        <p>Sales</p>
                                                    </td>
                                                    <td>

                                                        <p>0</p>
                                                    </td>
                                                </tr>

                                                <tr>

                                                    <td>
                                                        <div>
                                                            <img src={Avatar} />
                                                            <span>
                                                                <h4>Brad Simmons</h4>
                                                                <p>Lorem Epsum</p>
                                                            </span>

                                                        </div>
                                                    </td>
                                                    <td >
                                                        <h4>146</h4>
                                                        <p>Confirmed</p>
                                                    </td>
                                                    <td >
                                                        <h4>London</h4>
                                                        <p>UK</p>
                                                    </td>
                                                    <td>
                                                        <h4>Intertico</h4>
                                                        <p>Sales</p>
                                                    </td>
                                                    <td>

                                                        <p>0</p>
                                                    </td>
                                                </tr>


                                            </UiTable>
                                        </div>

                                        <div className='sb-league-tabl-sec__tbl-bot-footer'>
                                            <Button to="" className="sb-primary-btn--38">Manage Team</Button>
                                            <Button to="" className="sb-primary-btn--38" disabled>Allocate Points</Button>
                                        </div>

                                    </UiCol>
                                    <UiCol lg="12" xl="4">
                                        <UiContentCol>
                                            <div className='sb-league-tabl-sec__content'>
                                                <p>Timperdiet gravida scelerisque odio nunc. Eget felis, odio bibendum quis eget sit lorem donec diam. Volutpat sed orci turpis sit dolor est a pretium eget. Vitae turpis orci vel tellus cursus lorem vestibulum quis eu. Ut commodo, eget lorem venenatis urna.</p>
                                            </div>
                                        </UiContentCol>
                                    </UiCol>
                                </UiSingleRow>
                            </UiContentCol>
                        </UiCol>
                    </UiRowContainer>
                </UiContentWr> */}



                <TermsConditions />

                <Faq />

                <Footer />

            </UiMainWrapper>
        </>
    )
}



